<template>
    <ac-modal :title="'Add Group Offering'" ref="modal">
        <div v-if="widgetReady">
            <div class="row form-group">
                <div class="info-board info-board-blue">
                    Select an existing group offering below or create a
                    <router-link :to="{name:'createPlanOffering', params: {consultantId: this.consultantId}}">
                        new group offering
                    </router-link>
                </div>
                <div class="col-sm-6">
                    <label>
                        Group Offering
                        <small class="redText">required</small>
                    </label>
                    <select v-model="selectedPoolId" class="form-control">
                        <option v-for="availablePool in availablePools" 
                            :value="availablePool.planPoolId" :key="availablePool.planPoolId">
                            {{availablePool.name}} {{availablePool.allowProviderPlans ? "*" : ""}}
                        </option>
                    </select>
                </div>
                <div v-if="selectedPoolId" class="col-sm-6">
                    <ac-button class="btn btn-green btn-sm" style="margin-top: 25px;" :action="chooseOffering">
                        SELECT OFFERING
                    </ac-button>
                </div>
                <div class="col-sm-12">
                    <hr>
                </div>
            </div>
            <div v-if="selectedPoolId">
                <view-plans :consultantId="consultantId" :planPoolId="selectedPoolId">

                </view-plans>
            </div>
        </div>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import {common} from "../../../../global/common.js";
    import ViewPlans from './ViewPlans.vue';

    export default {
        name: "UpdatePlanModal",
        components: {ViewPlans},
        data() {
            return {
                widgetReady: false,
                consultantId: null,
                companyId: null,
                updatePlanName: null,
                availablePools: [],
                selectedPoolId: null,
            };
        },
        computed: {
            
        },
        methods: {
            async showModal({ consultantId, companyId, updatePlanName }) {
                this.widgetReady = false;
                this.consultantId = consultantId;
                this.companyId = companyId;
                this.updatePlanName = updatePlanName;

                // console.log("UpdatePlansModal showModal consultantId, companyId:", consultantId, companyId);

                this.availablePools = await api.get('MediatorPlan', consultantId, `GetAvailablePools/${companyId}`);
                this.widgetReady = true;
                this.$refs.modal.open();
            },
            async chooseOffering() {
                let args = {
                    planPoolId: this.selectedPoolId,
                    companyId: this.companyId,
                }
                // console.log("PlanPoolPreview chooseOffering args:", args);
                let result = await api.post('MediatorPlan', 'AssignPool', args);

                if (result) {
                    let pool = this.availablePools.find(x => x.planPoolId == this.selectedPoolId);
                    this.updatePlanName(pool.name);
                    this.$refs.modal.close();
                }
            }
        },
        watch: {
            selectedPoolId(newValue) {
                if (!newValue) this.plans = [];
            }
        }
    }
</script>

<style scoped>

</style>